/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import produce from "immer";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import {Button} from "primereact/button";
import alerts from "../../../shared/alerts";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import {Ruta} from "../cotizaciones/Rutas/ruta";
import * as numeral from "numeral";
import FieldTextArea from "../../../shared/controls/fieldTextArea";
import constantes from "../../constantes";
import DetalleRutaGrid from "../cotizaciones/Rutas/detalleRuta";
import Cliente from "../../../catalogos/clientes/cliente";
import Parada from "../paradas/parada";
import useApiConvenios from "../../../api/comercial/convenios";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import {FormatMoneda} from "../../../shared/utility";
import {useLoadingDispatch} from "../../../layout/show-loading-context";
import FieldMultiSelect from "../../../shared/controls/fieldMultiSelect";
import FieldRadioButtonList from "../../../shared/controls/fieldRadioButtonList";
import FieldInputNumber from "../../../shared/controls/fieldInputNumber";
import AgregarOrdenDeCompra from "./OrdenCompra";
import useSeguridad from "../../../Seguridad/useSeguridad";
import {default as constantesCatalogos} from "../../../catalogos/constantes";
import {useEmpresa} from "../../../layout/EmpresaProvider";
import Log from "../../../shared/Log";
import ModalConvenio from "./modalConvenio";
import ModalCostos from "./modalCostos";

const DetalleConvenio = () => {
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantesCatalogos.menus.convenios);
    const soloLecturaComercial = !seguridad.esEditable(constantesCatalogos.menus.comercial);
    const dispatchRoot = useLoadingDispatch();
    const [convenio, setConvenio] = useState({ruta: new Ruta(), moneda: constantes.monedaPeso, paradas: []});
    const [submitted, setSubmitted] = useState(false);
    const [detalleExpandido, setDetalleExpandido] = useState(false);
    const [editable, setEditable] = useState(false);
    const [puedeSuspender, setPuedeSuspender] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const apiConvenios = useApiConvenios();
    const history = useNavigate();
    const [conceptos, setConcepto] = useState(false);
    const [permisionarios, setpermisionarios] = useState(false);
    const [vigente, setVigente] = useState(false);
    const [mostrarOrdenCompra, setMostrarOrdenCompra] = useState();
    const [viajes, setViajes] = useState([]);
    const [impoExpo] = useState([
        {id: false, nombre: "Impo"},
        {id: true, nombre: "Expo"},
    ]);
    const [verModal, setVerModal] = useState(false);
    const [verModalGastos, setModalGastos] = useState(false);
    const [seleccionado, setSeleccionado] = useState([]);
    let {id} = useParams();
    const [errorSubCliente, setErrorSubCliente] = useState(false);
    const [erroPeso, setErrorPeso] = useState(false);
    const {disable: disableEmpresa, empresa} = useEmpresa();
    const [errors, setErrors] = useState({})
    // const [esUltimaEUA, setesUltimaEUA] = useState(false);
    useEffect(() => {
        cargarConvenio();
        disableEmpresa();
    }, []);

    async function cargarConvenio() {
        const convenio = await apiConvenios.obtener(id);
        setConvenio({...convenio, ruta: new Ruta(convenio.ruta)});
        console.log(convenio)
        // let ultimaParada = convenio.paradas?.[convenio.paradas.length - 1];
        //let esUltima = ultimaParada?.direccion?.pais?.id === constantesCatalogos.paises.eua;
        //setesUltimaEUA(esUltima)
        setEditable(
            convenio.estatus.id === constantes.estatusConvenios.altaPendiente ||
            convenio.estatus.id === constantes.estatusConvenios.vigente
        );
        setPuedeSuspender(convenio.estatus.id === constantes.estatusConvenios.vigente || convenio.clonado);
        dispatchRoot({type: "setDatosPath", datosPath: convenio?.numeroConvenio});
        setConcepto(convenio.conceptosCobro);
        setpermisionarios(convenio.permisionario);
        setVigente(convenio.estatus.id === constantes.estatusConvenios.vigente);
        setViajes(await apiConvenios.obtenerViajes(id));
        setSeleccionado(convenio.convenioCentroCostos?.filter(cc => cc.seleccionado));

    }

    async function actualizar(value, propertyName) {
        const setDirty = () => setIsDirty(true);

        if (propertyName === "internacional") {
            const viajes = await apiConvenios.validarImpoExpo(id, value);
            if (viajes.length > 0) {
                const ok = await alerts.preguntarSiNo(
                    `Existen ${viajes.length} viajes pendientes que se veran afectados, ¿deseas continuar?`
                );
                if (!ok) return;
            }
            setConvenio(prev => produce(prev, draft => {
                draft.internacional = value;
            }));
            setDirty();
            return;
        }

        if (propertyName === "conceptosCobro") {
            const list = value.map(c => {
                const concepto = conceptos.find(cc => cc.id === c.id);
                return {id: c.id, nombre: c.nombre, monto: concepto?.monto ?? 0};
            });

            setConvenio(prev => produce(prev, draft => {
                draft.conceptosCobro = list;
            }));
            if (conceptos.length < list.length) setConcepto(list);
            setDirty();
            return;
        }

        if (propertyName === "cliente") {
            setConvenio(prev => produce(prev, draft => {
                draft.cliente = value;
                draft.subCliente = {id: 0};
            }));
            setDirty();
            return;
        }

        if (propertyName === "subCliente") {
            setConvenio(prev => produce(prev, draft => {
                draft.subCliente = value;
            }));
            if (value?.id > 0) {
                const sub = await apiConvenios.obtenerSubcliente(value.id);
                setConvenio(prev => produce(prev, draft => {
                    draft.aplicaFrightVerify = sub?.aplicaFrightVerify;
                    draft.aplicaQS3 = sub?.aplicaQS3;
                }));
            }
            setDirty();
            return;
        }

        if (propertyName === "permisionario") {
            const picked = Array.isArray(value) ? value : [value];
            const nuevos = picked.map(c => {
                const cat = permisionarios.find(cc => cc.id === c.id);
                return {id: c.id, nombre: c.nombre, tarifa: cat?.tarifa ?? 0};
            });

            setConvenio(prev => produce(prev, draft => {
                const prevList = Array.isArray(draft.permisionario) ? draft.permisionario : [];
                const byId = new Map(prevList.map(x => [x.id, x]));
                for (const x of nuevos) {
                    byId.set(x.id, {...byId.get(x.id), ...x});
                }

                draft.permisionario = Array.from(byId.values());
            }));
            setDirty();
            return;
        }

        setConvenio(prev => produce(prev, draft => {
            draft[propertyName] = value;
        }));
        setDirty();
    }

    function actualizarParada(parada, index) {
        setConvenio(
            produce(convenio, (draft) => {
                draft.paradas[index] = parada;
            })
        );

        cargarConvenio();
    }

    async function back() {
        if (isDirty === false || (await alerts.preguntarSiDeseaSalirSinGuardar())) {
            history("/comercial");
        }
    }

    async function guardar() {
        setSubmitted(true);
        setErrorSubCliente(false);
        console.log(convenio)
        if (codigoRutaRequeridaError()) {
            return;
        }
        if (convenio.cliente?.esLogistico && (convenio.subCliente === null || convenio.subCliente === undefined)) {
            setErrorSubCliente(true);
            return;
        }
        if (convenio?.internacional) {

            if (convenio.paradas.some(p => p.esOrigen && !p.direccion?.rfc)) {
                await alerts.aviso("Capturar un RFC valido para la dirección origen.");
                return;
            }

            if (convenio.paradas.some(p => p.esDestino && !p.direccion?.rfc)) {
                await alerts.aviso("Capturar un RFC valido para la dirección destino.");
                return;
            }

            if (convenio?.impoExpo) {
                if (convenio?.paradas?.some(p => p.esOrigen && p.direccion?.pais?.id !== constantesCatalogos.paises.mexico && convenio.tipoViajeId !== constantes.tipoViaje.redondo)) {
                    await alerts.aviso("El origen no es valido para exportación.");
                    return;
                }

                if (convenio?.paradas?.some(p => p.esDestino && p.direccion?.pais?.id === constantesCatalogos.paises.mexico && convenio.tipoViajeId !== constantes.tipoViaje.redondo)) {
                    await alerts.aviso("El destino no es valido para exportación.");
                    return;
                }
            } else {
                if (convenio?.paradas?.some(p => p.esOrigen && p.direccion?.pais?.id === constantesCatalogos.paises.mexico)) {
                    await alerts.aviso("El origen no es valido para importación.");
                    return;
                }

                if (convenio?.paradas?.some(p => p.esDestino && p.direccion?.pais?.id !== constantesCatalogos.paises.mexico && convenio.tipoViajeId !== constantes.tipoViaje.redondo)) {
                    await alerts.aviso("El destino no es valido para exportación.");
                    return;
                }
            }
        }
        if (convenio?.peso === null) {
            setErrorPeso(true)
        }
        await apiConvenios.actualizar(id, {...convenio, estatus: convenio.estatus.id});
        history("/comercial");
    }

    async function registrar() {
        setSubmitted(true);
        setErrorSubCliente(false);
        const paradasConError = convenio.paradas.filter((e) => e.direccion == null).length > 0;
        //!!aqui hace la validación, si se agregan mas campos requeridos, mejor cambiarlo a esquema de validación!!
        if (clienteNoEncontrado() || paradasConError === true) {
            return;
        }
        if (codigoRutaRequeridaError()) {
            return;
        }

        if (convenio.cliente?.esLogistico && (convenio.subCliente === null || convenio.subCliente === undefined)) {
            setErrorSubCliente(true);
            return;
        }
        const respuesta = await alerts.preguntarSiNo("¿Desea registrar el convenio?");
        if (respuesta === false) {
            return;
        }
        await apiConvenios.setVigente(id, {...convenio, estatus: convenio.estatus.id});
        history("/comercial");
    }

    async function suspender() {
        if ((await alerts.preguntarSiNo("¿Desea suspender el Convenio?")) === false) {
            return;
        }
        await apiConvenios.suspender(id);
        history("/comercial");
    }

    function clienteNoEncontrado() {
        return !((convenio.cliente?.id ?? 0) > 0);
    }

    function ProveedorRequerido() {
        return (convenio.proveedor?.length ?? 0) === 0 && (convenio.aplicaFrightVerify || convenio.aplicaEdiAODMEX);
    }

    function codigoRutaRequeridaError(codigoRuta) {



        const nombre = convenio?.cliente?.nombre?.toLowerCase();
        const esAptiv = nombre?.includes("aptiv");
        const esRequerido = esAptiv || ((convenio.proveedor?.length ?? 0) === 0 && (convenio.aplicaFrightVerify || convenio.aplicaEdiAODMEX));

        if (!esRequerido) {
            setErrors({})
            return false;
        }

        codigoRuta = (codigoRuta ?? convenio.codigoRuta)?.trim() ?? '' ;

        if (codigoRuta.trim().length === 0) {
            setErrors({codigoRuta: 'requerido'})
            return true;
        }

        if (esAptiv && codigoRuta.length > 12) {
            setErrors({
                codigoRuta: {
                    message: 'El código de ruta debe tener máximo 12 caracteres',
                    type: 'matches'
                }
            })
            return true;
        }
        setErrors({})
        return false;

    }

    const actualizarConceptos = (value, propertyName, index) => {
        console.log('add')
        setConvenio(
            produce(convenio, (draft) => {
                if (draft.conceptosCobro[index]) {
                    draft.conceptosCobro[index][propertyName] = value;
                }
            })
        );
    };
    const actualizarConvenioPermisionarios = (value, propertyName, index) => {
        setConvenio(
            produce(convenio, (draft) => {

                if (!draft.permisionario[index]) return;
                if (propertyName === "monedaPermsionario" && value?.id) {
                    draft.permisionario[index][propertyName] = value.id;
                } else {
                    draft.permisionario[index][propertyName] = value;
                }
                console.log('tarifa')
                if (propertyName === "tarifaPermisionario") {
                    const item = draft.permisionario[index]
                    const tarifa = Number(value);
                    if (tarifa > 0) {
                        item.margenPermisionario = (convenio.ruta.facturacionMxn - tarifa / 100);
                    }
                }

            })
        );
    };

    function actualizarViajes(newViajes) {
        setViajes(newViajes);
    }

    async function actualizarOC(oc) {
        setConvenio(
            produce(convenio, (draft) => {
                draft.ordenesCompra.push(oc);
            })
        );

        setViajes(await apiConvenios.obtenerViajes(id));
    }

    const onUpdateFreightVerify = (checked) => {
        setConvenio({...convenio, aplicaFrightVerify: checked, aplicaQS3: checked ? false : convenio.aplicaQS3})
        setIsDirty(true);
    }

    const onUpdateQs3 = (checked) => {
        setConvenio({
            ...convenio,
            aplicaQS3: checked,
            aplicaFrightVerify: checked ? false : convenio.aplicaFrightVerify
        })
        setIsDirty(true);
    }

    const quitarConvenio = async () => {
        if (await alerts.preguntarSiNo("¿Quitar convenio relacionado?")) {
            await apiConvenios.guardarRelacionado(id, 0);
            cargarConvenio();
        }
    };
    const openmodalCostos = async () => {
        setModalGastos(true)
    }
    return (
        <>
            <div className="form-container">
                <div className={`form-filtro form-row`}>
                    <div className={`form-group col-md-4 col-sm-6`}>
                        <label htmlFor={"cliente"}>Cliente</label>
                        {clienteNoEncontrado() && (
                            <label className="autocomplete-not-found-item" style={{right: 150}}>
                                {" "}
                                No encontrado{" "}
                            </label>
                        )}
                        <div className="col-auto">
                            <FieldAutoComplete
                                name="cliente"
                                disabled={!editable}
                                source="clientes"
                                error={clienteNoEncontrado() === true && submitted}
                                freeText
                                showNotFound={true}
                                value={convenio.cliente}
                                onChange={actualizar}
                            />
                            {editable && (
                                <Cliente
                                    onSave={(nuevoCliente) => actualizar(nuevoCliente, "cliente")}
                                    soloLectura={soloLecturaComercial}
                                />
                            )}
                        </div>
                    </div>
                    <FieldCheckBox
                        label="Freight Verify"
                        name="aplicaFrightVerify"
                        disabled={!editable}
                        colMd={1}
                        colSm={2}
                        value={convenio.aplicaFrightVerify}
                        onChange={(e) => onUpdateFreightVerify(e)}
                    />
                    <FieldCheckBox
                        label="QS3"
                        name="aplicaQS3"
                        disabled={!editable}
                        colMd={1}
                        colSm={1}
                        value={convenio.aplicaQS3}
                        onChange={(e) => onUpdateQs3(e)}
                    />
                    <FieldCheckBox
                        label="Aplica Edi AODMEX"
                        name="aplicaEdiAODMEX"
                        disabled={!editable}
                        colMd={1}
                        colSm={2}
                        value={convenio.aplicaEdiAODMEX}
                        onChange={actualizar}
                    />
                    <FieldDropDown
                        name="estatus"
                        label="Estatus"
                        source="estatusConvenio"
                        showClear={false}
                        colMd={1}
                        disabled={true}
                        value={convenio.estatus}
                        onChange={actualizar}
                    />
                    <FieldCheckBox
                        label="Fuel"
                        name="aplicaFuel"
                        disabled={!editable}
                        colMd={1}
                        colSm={2}
                        value={convenio.aplicaFuel}
                        onChange={actualizar}
                    />
                    <FieldCheckBox
                        label="Internacional"
                        name={"internacional"}
                        disabled={!editable}
                        colMd={1}
                        colSm={2}
                        value={convenio?.internacional}
                        onChange={actualizar}/>

                    <FieldCheckBox
                        label="Restringir Op."
                        name="restringirOp"
                        disabled={!editable}
                        colMd={1}
                        colSm={2}
                        value={convenio.restringirOp}
                        onChange={actualizar}
                    />

                    {convenio.internacional && (
                        <>
                            <div className={`form-group col-md-2 col-sm-4`}>
                                <FieldRadioButtonList
                                    options={impoExpo}
                                    name="impoExpo"
                                    colMd={2}
                                    disabled={!editable}
                                    value={convenio?.impoExpo}
                                    onChange={actualizar}/>
                            </div>
                        </>
                    )}
                    <>
                        <div className={`form-group col-md-2 col-sm-4`}>
                            <FieldRadioButtonList
                                options={impoExpo}
                                name="convenioImpoExpo"
                                colMd={2}
                                disabled={!editable}
                                value={convenio?.convenioImpoExpo}
                                onChange={actualizar}/>
                        </div>
                    </>
                    <>
                        <div className={`form-group col-md-2 col-sm-4`}>
                            <FieldRadioButtonList
                                options={impoExpo}
                                name="convenioImpoExpo"
                                colMd={2}
                                disabled={!editable}
                                value={convenio?.convenioImpoExpo}
                                onChange={actualizar}/>
                        </div>
                    </>
                    <div className="field-iconos btn-group">
                        <ButtonIcon title="Regresar" iconName={"BiArrowBack"} onClick={back}/>
                        {!soloLecturaComercial && (
                            <>
                                {puedeSuspender && (
                                    <ButtonIcon title="Cancelar" iconName={"FcCancel"} onClick={suspender}/>
                                )}

                                {editable && (
                                    <>
                                        <ButtonIcon title="Guardar" iconName={"AiOutlineSave"} onClick={guardar}/>
                                        <ButtonIcon
                                            title="Alta de Convenio"
                                            className="action"
                                            iconName={"FaCheckCircle"}
                                            onClick={registrar}
                                            disabled={vigente}
                                        />
                                    </>
                                )}

                            </>
                        )}
                    </div>
                </div>
                <div style={{marginTop: "-15px"}} className={`form-filtro form-row`}>
                    {convenio.cliente?.esLogistico && (

                        <FieldDropDown
                            name="subCliente"
                            label="SubCliente"
                            source="subClientes"
                            required={true}
                            error={errorSubCliente}
                            params={{clienteId: convenio.cliente?.id}}
                            showClear={true}
                            colMd={2}
                            value={convenio.subCliente}
                            onChange={actualizar}
                        />
                    )}

                    <FieldTextBox name={"cotizacion"} label={'Cotizacion'} value={convenio.cotizacion} colMd={1}
                                  disabled={true}></FieldTextBox>
                    <FieldInputNumber name={"peso"} label={'Peso'} value={convenio.peso} colMd={1} error={erroPeso}
                                      required={true} onChange={actualizar}/>
                    {/* {esUltimaEUA &&       */}
                    <FieldInputNumber name={"facturacionSegmentoAmericano"} label={'Facturacion Segmento Americano'}
                                      value={convenio.facturacionSegmentoAmericano} colMd={2} fractionDigits={2}
                                      maxLength={6} onChange={actualizar}/>
                    {/* } */}
                    <div style={{marginLeft: '50px', display: 'flex', alignItems: 'center'}}>
                        <FieldRadioButtonList source="clasificacionesCarga" name="clasificacionCargaId"
                                              disabled={true}
                                              value={convenio.clasificacionCarga}>
                        </FieldRadioButtonList>
                    </div>
                    <div style={{marginLeft: '50px', display: 'flex', alignItems: 'center'}}>
                        <FieldRadioButtonList source="clasificacionesRuta" name="clasificacionRuta"
                                              disabled={true}
                                              value={convenio.clasificacionRuta}>
                        </FieldRadioButtonList>
                    </div>
                    <FieldCheckBox
                        label="No enviar eventos al cliente en automático"
                        name="evitarEnvioAutomaticoEventos"
                        disabled={!editable}
                        colMd={2}
                        colSm={4}
                        value={convenio.evitarEnvioAutomaticoEventos}
                        onChange={actualizar}
                    />
                    <FieldCheckBox
                        label="Comisión Bloqueada"
                        name="bloqueoComision"
                        disabled={!editable}
                        colMd={2}
                        colSm={4}
                        value={convenio.bloqueoComision}
                        onChange={actualizar}
                    />
                    <FieldCheckBox
                        label="Clonado"
                        name="clonado"
                        disabled={true}
                        colMd={2}
                        colSm={4}
                        value={convenio.clonado}
                        onChange={actualizar}
                    />

                </div>

                <div style={{marginTop: "-15px"}} className={`form-filtro form-row`}>
                    {convenio.convenioCentroCostos != null && (
                        <FieldMultiSelect
                            showFilter={false}
                            maxSelectedLabels={12}
                            disabled={!editable}
                            name="convenioCentroCostos"
                            label="Centro de Costos"
                            source="clienteCentroCostos"
                            required={true}
                            error={errorSubCliente}
                            params={{clienteId: convenio.cliente?.id}}
                            showClear={true}
                            colMd={2}
                            value={seleccionado}
                            onChange={actualizar}

                        />
                    )}
                </div>
                <div className={`section-container ${submitted === true ? "submitted" : ""}`}>
                    <div className="flex-col-12 ">
                        <h5>Ruta</h5>
                        <div style={{display: "flex", justifyContent: "flex-end"}}>
                            {/* {!convenio.editarCostos && ( */}
                                <Button
                                    label="Editar Costos"
                                    style={{width: 170, marginTop: '-50px'}}
                                    className="p-button-text"
                                    icon="pi pi-plus-circle"
                                    onClick={openmodalCostos}
                                />
                            {/* )} */}
                        </div>
                        <table className="table table-borderless">
                            <thead>
                            <tr>
                                <th style={{width: 20}}/>
                                <th>ORIGEN</th>
                                <th>DESTINO</th>
                                <th>TIPO VIAJE</th>
                                <th>TIPO UNIDAD</th>
                                <th>{convenio?.ruta?.unidadDeMedida?.abreviatura}</th>
                                <th>COSTO RUTA</th>
                                <th>FACTURACIÓN</th>
                                <th>PRECIO POR {convenio?.ruta?.unidadDeMedida?.abreviatura}</th>
                                <th>UTILIDAD</th>
                                <th>MARGEN</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="input">
                                    {detalleExpandido !== true && (
                                        <ButtonIcon
                                            title={"Expander"}
                                            iconName={"MdExpandMore"}
                                            onClick={() => setDetalleExpandido(true)}
                                        />
                                    )}
                                    {detalleExpandido === true && (
                                        <ButtonIcon
                                            title={"Contraer"}
                                            iconName={"MdExpandLess"}
                                            onClick={() => setDetalleExpandido(false)}
                                        />
                                    )}
                                </td>
                                <td>{convenio.ruta.viaje.origen?.nombre}</td>
                                <td>{convenio.ruta.viaje.destino?.nombre}</td>
                                <td>{convenio.ruta.viaje.tipoViajeNombre}</td>
                                <td>{convenio.ruta.viaje.tipoUnidad?.nombre}</td>
                                <td>{numeral(convenio.ruta.costo.longitud).format("0,0.00")}</td>
                                <td>{numeral(convenio.ruta.costo.costoRuta).format("$0,0.00")}</td>
                                <td>
                                    <div>{numeral(convenio.ruta.facturacionMxn).format("$0,0.00")}</div>
                                    {convenio.ruta.montoFacturacionUsd && empresa.moneda.id !== constantes.monedaUsd.id && (
                                        <div>
                                            {new FormatMoneda(true, convenio.ruta.tipoDeCambio).format(
                                                convenio.ruta.facturacionMxn
                                            )}
                                        </div>
                                    )}
                                </td>
                                <td>{numeral(convenio.ruta.precioPorKilometro).format("$0,0.00")}</td>
                                <td>{numeral(convenio.ruta.utilidad).format("$0,0.00")}</td>
                                <td>{convenio.ruta.margen}</td>
                            </tr>
                            <tr>
                                {detalleExpandido === true && (
                                    <td colSpan={11}>
                                        <DetalleRutaGrid data={convenio.ruta}/>
                                    </td>
                                )}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="flex-col-6">
                        <h5>Conceptos de cobro</h5>
                        <div className={`form-filtro form-row`}>
                            <FieldRadioButtonList
                                name="moneda"
                                source="monedas"
                                valueIsObject={true}
                                disabled={true}
                                value={convenio.moneda}
                                onChange={actualizar}
                            />
                        </div>


                        <div className={`form-filtro form-row`}>
                            <div className="form-group col-md-6 col-sm-6 text-right">
                                <label>Seleccionar Concepto de Cobro</label>
                            </div>
                            <div className="form-group col-md-6 col-sm-6">
                                <FieldMultiSelect
                                    showFilter={false}
                                    maxSelectedLabels={12}
                                    disabled={!editable}
                                    name="conceptosCobro"
                                    source="conceptosCobro"
                                    colMd={4}
                                    value={convenio.conceptosCobro}
                                    onChange={actualizar}
                                />
                            </div>
                        </div>
                        {/* <div className={`form-filtro form-row`}>
                            {convenio?.conceptosCobro?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <FieldInputNumber
                                        name="concepto"
                                        value={item.monto}
                                        required
                                        label={`${item.nombre}`}
                                        colMd={3}
                                        onChange={(e) => actualizarConceptos(e, index)}
                                        fractionDigits={2}
                                        maxLength={6}
                                    />
                                </React.Fragment>
                            ))}
                        </div>
                        <div className={`form-filtro form-row`}>                         
                        {convenio?.conceptosCobro?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <FieldCheckBox
                                    label="Timbrado"
                                    name="conceptoTimbrado"                                       
                                    colMd={1}
                                    colSm={2}
                                    value={item.conceptoTimbrado}
                                    onChange={actualizar}
                                />
                                </React.Fragment>
                            ))}
                        </div> */}

                        <table className="table table-borderless">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col" style={{width: "30%"}}>Concepto de cobro</th>
                                <th scope="col" style={{width: "50%"}}>Monto</th>
                                <th scope="col" style={{width: "20%"}}>Timbrado</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(convenio?.conceptosCobro || []).map((item, index) => {

                                return (
                                    <tr key={index}>
                                        <td>{item.nombre}</td>
                                        <td>
                                            <React.Fragment key={index}>
                                                <FieldInputNumber
                                                    name="monto"
                                                    value={item.monto}
                                                    required
                                                    label={item.nombre}
                                                    colMd={3}
                                                    onChange={(value, pname) => actualizarConceptos(value, pname, index)}
                                                    fractionDigits={2}
                                                    maxLength={6}
                                                />
                                            </React.Fragment>
                                        </td>
                                        <td>
                                            <React.Fragment key={index}>
                                                <FieldCheckBox
                                                    label="Timbrado"
                                                    name="conceptoTimbrado"
                                                    colMd={1}
                                                    colSm={2}
                                                    value={item.conceptoTimbrado}
                                                    onChange={(value, pname) => actualizarConceptos(value, pname, index)}
                                                />
                                            </React.Fragment>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>


                        <h5>Adicionales</h5>
                        <table className="table table-borderless">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col" style={{width: "40%"}}>
                                    ACCESORIO
                                </th>
                                <th scope="col" style={{width: "20%"}}>
                                    CANTIDAD
                                </th>
                                <th scope="col" style={{width: "20%"}} className="right">
                                    PRECIO UNITARIO
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {convenio.ruta.accesorios.map((accesorio, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{accesorio.accesorioNombre}</td>
                                        <td>{accesorio.cantidad}</td>
                                        <td className="right">{numeral(accesorio.precio).format("$0,0.00")}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td/>
                                <td colSpan={2} className="right">
                                    Total: {numeral(convenio.ruta.totalAccesorios).format("$0,0.00")}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="flex-col-6">
                        <h5>Generales</h5>
                        <div className={`form-filtro form-row`}>
                            <FieldTextBox
                                name="proveedor"
                                label="No. Proveedor / Transportista"
                                colMd={4}
                                disabled={!editable}
                                error={ProveedorRequerido() === true && submitted}
                                value={convenio.proveedor}
                                onChange={actualizar}
                            />
                            <FieldTextBox
                                name="codigoRuta"
                                label="Código Ruta"
                                colMd={4}
                                disabled={!editable}
                                value={convenio.codigoRuta}
                                onChange={(value, propertyName)=> {
                                    codigoRutaRequeridaError(value);
                                    actualizar(value, propertyName).then();
                                }
                                }
                                errors={submitted ? errors : {}}
                            />
                            <div className={`form-group col-md-2 col-sm-6}`}>
                                <label>&nbsp;</label>
                                <FieldRadioButtonList
                                    name="moneda"
                                    source="monedas"
                                    valueIsObject={true}
                                    disabled={!convenio.editarMoneda}
                                    value={convenio.moneda}
                                    onChange={actualizar}
                                />
                            </div>
                        </div>
                        <h6>Comentarios</h6>
                        <FieldTextArea value={convenio.ruta.comentario} rows={2} disabled/>
                        <h6>Notas</h6>
                        <FieldTextArea value={convenio.ruta.nota} rows={2} disabled/>
                    </div>
                    <div className="flex-col-12" style={{overflow: "auto"}}>
                        <h5>Origen . . . Destino</h5>
                        <div style={{width: "100px"}} className="com-paradas">
                            <Parada
                                esSeparador={true}
                                labelClassName="com-parada-ruta-label"
                                textoBody="RUTA"
                                clienteId={0}
                                parada={{id: 0}}
                                subClienteId={0}
                                convenioId={id}
                            />
                            {convenio.paradas.map((parada, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Parada
                                            parada={parada}
                                            entidadId={id}
                                            api={apiConvenios}
                                            onChange={(e) => actualizarParada(e, index)}
                                            readOnly={soloLectura}
                                            clienteId={convenio?.cliente?.id ?? 0}
                                            onSave={cargarConvenio}
                                            subClienteId={convenio?.subCliente?.id ?? 0}
                                            convenioId={id}
                                        />
                                        {index < convenio.paradas.length - 1 && (
                                            <Parada
                                                labelClassName="com-parada-puntos"
                                                textoHeader="..."
                                                textoBody="..."
                                                esSeparador={true}
                                                clienteId={0}
                                                parada={{id: 0}}
                                                subClienteId={convenio?.subCliente?.id ?? 0}
                                                convenioId={id}
                                            />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex-col-6">
                        <h5>Tarifa Permisionarios</h5>

                        <div className={`form-filtro form-row`}>
                            <div className="form-group col-md-6 col-sm-6 text-right">
                                <label>Seleccionar Permisionario</label>
                            </div>
                            <div className="form-group col-md-6 col-sm-6">
                                <FieldMultiSelect
                                    showFilter={false}
                                    maxSelectedLabels={12}
                                    disabled={!editable}
                                    name="permisionario"
                                    source="permisionarios"
                                    colMd={4}
                                    value={convenio.permisionarios}
                                    onChange={(val) => actualizar(val, "permisionario")}
                                />
                            </div>
                        </div>

                        <table className="table table-borderless">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col" style={{width: "20%"}}>Permisionario</th>
                                <th scope="col" style={{width: "20%"}}>Moneda</th>
                                <th scope="col" style={{width: "20%"}}>Tarifa</th>
                                <th scope="col" style={{width: "20%"}}>Margen</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(convenio?.permisionario || []).map((item, index) => {

                                return (
                                    <tr key={index}>
                                        <td>{item.nombre ?? item.nombrePermisionario}</td>
                                        <td>
                                            <div className={`form-group col-md-2 col-sm-4`}>
                                                <React.Fragment key={index}>
                                                    <FieldRadioButtonList
                                                        name="monedaPermisionario"
                                                        source="monedas"
                                                        valueIsObject={true}
                                                        disabled={false}
                                                        value={item.monedaPermisionario}
                                                        onChange={(value, pname) => actualizarConvenioPermisionarios(value, pname, index)}
                                                    />
                                                </React.Fragment>
                                            </div>
                                        </td>
                                        <td>
                                            <React.Fragment key={index}>
                                                <FieldInputNumber
                                                    name="tarifaPermisionario"
                                                    value={item.tarifaPermisionario}
                                                    required
                                                    colMd={3}
                                                    onChange={(value, pname) => actualizarConvenioPermisionarios(value, pname, index)}
                                                    fractionDigits={2}
                                                    maxLength={6}
                                                />
                                            </React.Fragment>
                                        </td>
                                        <td>
                                            <React.Fragment key={index}>
                                                <FieldTextBox
                                                    name="margenPermisionario"
                                                    disabled={true}
                                                    colMd={6}
                                                    value={item.margenPermisionario}
                                                    onChange={(value, pname) => actualizarConvenioPermisionarios(value, pname, index)}
                                                />
                                            </React.Fragment>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>


                    </div>

                    <div className={"flex-col-6"}>
                        <h5>Convenio Relacionado</h5>
                        <div className="d-flex align-items-center">
                            {!soloLecturaComercial &&
                                <>
                                    <div>
                                        {convenio.convenioRelacionado}
                                    </div>
                                    <div className="table-button flex-grow-1">
                                        {convenio?.convenioRelacionado?.length > 0 ?
                                            <ButtonIcon title="Quitar Conveio" className="grid-action"
                                                        iconName={'BiEraser'}
                                                        onClick={quitarConvenio}/>
                                            :
                                            <ButtonIcon title="Guardar" className="grid-action"
                                                        iconName={'FaRegEdit'}
                                                        onClick={() => setVerModal(true)}/>
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div className="flex-col-6">
                        {convenio?.requiereOrdenCompra && (
                            <>
                                <div className="form-row mt-2">
                                    <div className="col-11">
                                        <h5>Ordenes de compra</h5>
                                    </div>
                                    <div className="col-1 align-items-end header-icons">
                                        {!soloLectura && (
                                            <div className="d-flex" style={{float: "right"}}>
                                                <ButtonIcon
                                                    title="Agregar orden de compra"
                                                    className={"grid-action"}
                                                    iconName={"MdAddBox"}
                                                    onClick={() => setMostrarOrdenCompra(true)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <table className="table table-borderless">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col" style={{width: "30%"}} className="center">
                                            ORDEN DE COMPRA
                                        </th>
                                        <th scope="col" style={{width: "20%"}} className="center">
                                            VIAJES TOTALES
                                        </th>
                                        <th scope="col" style={{width: "20%"}} className="center">
                                            VIAJES REALIZADOS
                                        </th>
                                        <th scope="col" style={{width: "10%"}} className="center">
                                            ACTIVA
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {convenio?.ordenesCompra?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="center">{item.ordenCompra}</td>
                                                <td className="center">{item.viajesTotales}</td>
                                                <td className="center">{item.viajesRealizados}</td>
                                                <td className="center">{item.actual}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                    <div className={'flex-col-6'}>
                        <div>
                            <Log data={convenio.logs ?? []}></Log>
                        </div>
                    </div>
                    <div className={'flex-col-12'}>
                        <h5>Ruta Asignada</h5>
                        <div>
                            <FieldTextBox
                                name="linkruta"
                                label="Link Ruta Maps"
                                colMd={12}
                                disabled={!editable}
                                value={convenio.linkRuta}
                                onChange={actualizar}
                                rows={4}
                                style={{width: '100%'}}
                                title={convenio.linkRuta}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AgregarOrdenDeCompra
                convenioId={id}
                viajes={viajes}
                visible={mostrarOrdenCompra}
                hide={() => setMostrarOrdenCompra(false)}
                onChange={actualizarViajes}
                update={actualizarOC}
            />
            <ModalConvenio visible={verModal} hide={() => setVerModal(false)} id={id} onChange={actualizar}
                           onSave={cargarConvenio}/>
            <ModalCostos
                visible={verModalGastos}
                hide={() => setModalGastos(false)}
                rutaInicial={convenio.ruta}
                convenio={convenio}
                unidadDeMedida={convenio.ruta?.unidadDeMedida}
                viaje={convenio.ruta?.viaje}
                editable={true}
                puedeModificarCosto={true}
                modificarComentarios={true}
                id={convenio.cotizacion}
                onGuardar={(rutaActualizada) => {
                    cargarConvenio(rutaActualizada);
                    setModalGastos(false);
                }}
            />
        </>
    );
};

export default DetalleConvenio;
